// The five animated "working" spark variants. "" is the original 84-frame webp
// spark (the .ca-spark default); the rest are modifier suffixes matching the
// .ca-spark--<name> classes in EventList.css. One is rolled at random per user
// turn (alongside the working word) so each response gets its own animation.
export const SPARK_VARIANTS = ["", "thinking", "orbiting", "writing", "shimmer"];

export function randomSparkVariant() {
  return SPARK_VARIANTS[Math.floor(Math.random() * SPARK_VARIANTS.length)];
}
